let usage = `
<MultiSelect v-model="multiSelectValue"
             :options="options"
             title="Type:"
             titleIcon="tags-solid">
</MultiSelect>
`.slice(1);

export default {
  usage
};
